var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXpLevel1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.884,
    height: 37.884,
    viewBox: "0 0 37.884 37.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3074",
    "data-name": "Group 3074",
    transform: "translate(-997 -565.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3030",
    "data-name": "Group 3030",
    transform: "translate(997 565.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2974",
    "data-name": "Group 2974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3031",
    "data-name": "Group 3031"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32787",
    "data-name": "Path 32787",
    d: "M33.735,33.734a17.432,17.432,0,1,1,0-24.653,17.432,17.432,0,0,1,0,24.653",
    transform: "translate(-2.467 -2.466)",
    fill: "#bcc5ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32788",
    "data-name": "Path 32788",
    d: "M40,40a10.671,10.671,0,1,1,0-15.091A10.671,10.671,0,0,1,40,40",
    transform: "translate(-13.51 -13.51)",
    fill: "#bcc5ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32790",
    "data-name": "Path 32790",
    d: "M18.941,37.883a18.942,18.942,0,1,1,13.4-5.541,18.892,18.892,0,0,1-13.4,5.541m0-34.848A15.906,15.906,0,1,0,30.194,7.689,15.864,15.864,0,0,0,18.941,3.036M31.268,31.268h0Z",
    transform: "translate(0 0)",
    fill: "#4a4e59"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_32980",
    "data-name": "Path 32980",
    d: "M4.046,9.366A.676.676,0,0,1,5,9.406a3.029,3.029,0,0,0,4.414,0,.674.674,0,1,1,.991.915,4.373,4.373,0,0,1-6.4,0A.654.654,0,0,1,4.046,9.366ZM9.02,6.306a.9.9,0,1,1,.9.9A.9.9,0,0,1,9.02,6.306Zm-3.6,0a.9.9,0,1,1-.9-.9A.9.9,0,0,1,5.417,6.306ZM0,7.207A7.2,7.2,0,0,1,.241,5.355.451.451,0,0,1,.45,4.5H.524a7.21,7.21,0,0,1,13.367,0h.073a.452.452,0,0,1,.45.45.458.458,0,0,1-.239.4,7.3,7.3,0,0,1,.239,1.852A7.207,7.207,0,0,1,0,7.207Zm7.207,5.856a5.855,5.855,0,0,0,5.856-5.856c0-.051-.025-.1,0-.149a1.575,1.575,0,0,1-1.574,1.5H9.234A1.578,1.578,0,0,1,7.657,6.982V5.63a1.488,1.488,0,0,1,.017-.225H6.74a1.488,1.488,0,0,1,.017.225V6.982A1.578,1.578,0,0,1,5.18,8.558H2.928a1.576,1.576,0,0,1-1.575-1.5c0,.051,0,.1,0,.149a5.855,5.855,0,0,0,5.856,5.856ZM6.306,4.5h1.8v.023a1.569,1.569,0,0,1,1.126-.473h2.252a1.57,1.57,0,0,1,.783.208,5.857,5.857,0,0,0-10.124,0,1.571,1.571,0,0,1,.783-.208H5.18a1.569,1.569,0,0,1,1.126.473ZM8.558,6.982a.674.674,0,0,0,.676.676h2.252a.674.674,0,0,0,.676-.676V5.63a.674.674,0,0,0-.676-.676H9.234a.674.674,0,0,0-.676.676ZM2.928,4.955a.675.675,0,0,0-.676.676V6.982a.675.675,0,0,0,.676.676H5.18a.674.674,0,0,0,.676-.676V5.63a.674.674,0,0,0-.676-.676Z",
    transform: "translate(1008.735 577.598)",
    fill: "#4a4e59"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpLevel1);
export default __webpack_public_path__ + "static/media/xpLevel1.f17ba4c667355c3817f5b577d5f8fd33.svg";
export { ForwardRef as ReactComponent };